import React, { useEffect, useState } from "react";
import { UtensilsCrossed, Users, Boxes, Wallet } from "lucide-react";
import api from "../lib/api";
import { Card } from "../lib/ui";
import { fmtRp, fmtNum } from "../lib/constants";
import { useT } from "../lib/i18n";
import { useAuth } from "../context/AuthContext";

// 'Konsumsi Karyawan Bulan Ini' — current-month employee meal totals.
// Renders nothing if the user lacks permission or there's no data yet.
export default function EmployeeMealWidget({ branchId = null }) {
  const { t } = useT();
  const { hasPermission } = useAuth();
  const [d, setD] = useState(null);

  useEffect(() => {
    if (!hasPermission("view_employee_meal")) { setD({ skip: true }); return; }
    const qs = branchId ? `?branch_id=${branchId}` : "";
    api.get(`/employee-meals/widget${qs}`).then(({ data }) => setD(data)).catch(() => setD({ skip: true }));
  }, [branchId, hasPermission]);

  if (!d || d.skip) return null;

  return (
    <Card className="p-4 sm:p-5" data-testid="employee-meal-widget">
      <div className="mb-3 flex items-center gap-2">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-light text-primary"><UtensilsCrossed size={17} /></span>
        <div>
          <h3 className="font-heading text-sm font-extrabold text-ink">{t("Employee Meal This Month")}</h3>
          <p className="text-[11px] text-ink-mute">{t("Legitimate staff consumption — not waste or leakage")}</p>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <Mini icon={Wallet} label={t("Total Cost")} value={fmtRp(d.total_cost)} testid="emeal-widget-cost" />
        <Mini icon={Boxes} label={t("Total Qty")} value={fmtNum(d.total_qty)} testid="emeal-widget-qty" />
        <Mini icon={Users} label={t("Employees Fed")} value={fmtNum(d.total_employees)} testid="emeal-widget-employees" />
      </div>
    </Card>
  );
}

function Mini({ icon: Icon, label, value, testid }) {
  return (
    <div className="rounded-xl bg-stone-50 p-2.5 text-center" data-testid={testid}>
      <Icon size={15} className="mx-auto mb-1 text-primary" />
      <p className="text-sm font-extrabold text-ink">{value}</p>
      <p className="text-[10px] font-semibold uppercase text-ink-mute">{label}</p>
    </div>
  );
}
